<div class="video-call-container" [class.video-call-container--fullscreen]="isFullScreenVideoCall()">
  @if (!isLoadingSettings) { @if (!callEnd) {
  <div
    class="cams"
    [class.cams--solo]="members.length <= 1"
    [class.cams--pair]="members.length === 2"
    [class.cams--grid]="members.length > 2">
    @for (member of members; track member.agoraUid) {
    <ngx-video
      [member]="member"
      [members]="members.length"
      [rtc]="rtc"
      [ngStyle]="{ width: calcVideoWidth(), height: calcVideoHeight() }"
      class="video"></ngx-video>
    } @if (isLoadingCall) {
    <div class="video-calling">
      <div class="video-calling__text">
        <messaging-avatar
          [src]="$safeNavigationMigration(videoCall()?.pic)"
          [name]="$safeNavigationMigration(videoCall()?.name)"
          [initialsSize]="2"
          size="40">
        </messaging-avatar>
        <h2>
          @if (videoCall()?.type === 0) {
          {{ 'NGX-MESSAGING.VIDEO.callingTo' | translate }} {{ videoCall()?.name }}... } @else {
          {{ 'NGX-MESSAGING.VIDEO.connectingWith' | translate }} {{ videoCall()?.name }}... }
        </h2>
      </div>
    </div>
    }
  </div>
  <div class="video-call-options">
    <div class="video-call-options__name">
      {{ 'NGX-MESSAGING.VIDEO.time' | translate }} <b>{{ display }}</b>
    </div>
    <div class="video-call-options__principal">
      <button
        type="button"
        [class.video-call-options__button--off]="!video"
        (click)="setVideo(!video, rtc.client!.uid!, true)"
        class="video-call-options__button">
        <mat-icon class="video-call-options__icons" [svgIcon]="video ? 'videocam' : 'videocam_off'"></mat-icon>
      </button>
      <button
        type="button"
        [class.video-call-options__button--off]="!audio"
        (click)="setAudio(!audio, rtc.client!.uid!, true)"
        class="video-call-options__button">
        <mat-icon class="video-call-options__icons" [svgIcon]="audio ? 'mic' : 'mic_off'"></mat-icon>
      </button>
      <button type="button" (click)="leaveCall()" class="video-call-options__button video-call-options__button--end">
        <mat-icon class="video-call-options__end-call" svgIcon="call_end"></mat-icon>
      </button>
    </div>
    <div class="video-call-options__options">
      @if (expand && !isVideoCallView) {
      <button type="button" class="video-call-options__button" (click)="expandView()">
        <mat-icon
          class="video-call-options__icons"
          [svgIcon]="!isFullScreenVideoCall() ? 'fullscreen' : 'fullscreen_exit'"></mat-icon>
      </button>
      }
    </div>
  </div>
  } @else {
  <div class="loading video-call-ended">
    <h1>{{ 'NGX-MESSAGING.VIDEO.callEnded' | translate }} {{ display }}</h1>
  </div>
  } } @else {
  <div class="loading video-call-loading">
    <div>
      <mat-spinner [diameter]="48"></mat-spinner>
      <h1>{{ 'NGX-MESSAGING.loading' | translate }}...</h1>
    </div>
  </div>
  }
</div>
